import * as yup from 'yup'

export const site = yup.object().shape({
  nombre: yup.string().required('La empresa es obligatorio'),
  clienteId: yup.string().required('El cliente es obligatorio'),
  companiaId: yup.string().required('La compañía es obligatorio'),
  departamentoId: yup.string().required('El departamento es obligatorio'),
  provinciaId: yup.string().required('La provincia es obligatorio'),
  ubigeoId: yup.string().required('El distrito es obligatorio'),
  direccion: yup.string().required('La dirección es obligatorio'),
  referencia1: yup.string().required('La referencia 1 es obligatorio'),
  integComensalHuesped: yup.string().required('La referencia 1 es obligatorio'),
})
